import { collection, getDocs, limit, query } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * Tests the Firestore connection by attempting to read from a collection
 */
export const testFirestoreConnection = async (): Promise<boolean> => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const snapshot = await getDocs(query(collection(db, 'eventEditions'), limit(1)));
    return true;
  } catch (error) {
    // Firestore connection test failed
    return false;
  }
};
